export default __webpack_public_path__ + "static/media/person-tips-oldman.ae344e12.svg";